import { useSelector } from 'react-redux';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { ON_PREMISE } from 'server/constants/environment';

export const useVKTechBanner = () => {
    const isB2BUser = useSelector(UserSelectors.isB2BUser);

    const showVKTechBanner = isB2BUser && !ON_PREMISE;

    return {
        showVKTechBanner,
    };
};
